<template>
  <div
    class="shortBox"
    :style="{ top: getTopStyle, left: getLeftStyle }"
    @contextmenu.prevent
  >
    <div v-if="isVisible" class="Box">
      <!-- 箭头 -->
      <div
        :class="direction == 'left' ? 'shoartArrowLeft' : 'shoartArrowTop'"
      ></div>
      <div class="content">
        <span class="font">{{ $t('shortChain.stext1') }}</span>
        <div class="rightBox" @click="closeTooltip">
          <svg-btn class="icon" icon-class="icon-deepseek-yes" />
          <span class="font2">{{ $t('shortChain.earlyAccess') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSwitchs } from '@/utils/apiList/chat'
export default {
  name: 'ShortTooltip',
  props: {
    top: {
      type: Number,
      default: -1000,
      validator: value => {
        if (typeof value !== 'number') {
          return false
        }
        return true
      },
    },
    left: {
      type: Number,
      default: -1000,
      validator: value => {
        if (typeof value !== 'number') {
          return false
        }
        return true
      },
    },
    direction: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    getTopStyle() {
      return `${this.top}px`
    },
    getLeftStyle() {
      return `${this.left}px`
    },
  },
  watch: {
    $route(to, from) {
      if (to.path == '/shortChain') {
        this.isVisible = false
        localStorage.setItem('showShort', 3)
      }
    },
  },
  mounted() {
    this.getShort()
  },
  methods: {
    getShort() {
      getSwitchs().then(res => {
        const showShort = localStorage.getItem('showShort')
        if (res.status == 1) {
          const { short_url_switch, short_url_prompt_switch } = res.data.switchs
          this.$store.commit('setAttr', {
            name: 'short_url_switch',
            val: short_url_switch,
          })
          if (
            short_url_switch == 1 &&
            short_url_prompt_switch == 1 &&
            (showShort == 2 || showShort == null)
          ) {
            this.isVisible = true
            localStorage.setItem('showShort', 2)
          } else {
            this.isVisible = false
            // localStorage.setItem('showShort', 3)
          }
          //如果在登录状态下，且短链开关关闭，并且当前路由为短链路由，则返回到首页
          if (
            this.$utils.getCookie(Vue.prototype.$glb.fmCookieName) &&
            short_url_switch != 1 &&
            this.$route.name == 'shortChain'
          ) {
            this.$router.push({ path: '/homeCollection' })
          }
        }
      })
    },
    closeTooltip() {
      // 关闭提示框的逻辑
      this.isVisible = false
      localStorage.setItem('showShort', 3)
      this.$router.push({ path: '/shortChain' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
